exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.1/css/all.min.css);", ""]);
exports.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome-animation/0.3.0/font-awesome-animation.css);", ""]);

// module
exports.push([module.id, ".pdfFrame {\n  left: 0px;\n  top: 0px;\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  height: 80vh;\n  justify-content: center;\n  position: relative;\n  width: 100%; }\n\nhtml {\n  min-height: 100%; }\n\nbody {\n  min-height: 100%; }\n\n.spinner {\n  font-size: 100px; }\n\n.loader {\n  position: relative;\n  z-index: 10; }\n\n.loaded {\n  font-size: 1.2em;\n  font-weight: bold;\n  margin-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./modules/book/css/book.scss
// module id = 671
// module chunks = 0